<template>
  <v-layout px-2 py-2 mt-1 row wrap>
    <v-flex px-2>
      <a-form-view
        :value="data"
        :model="getFormModel(['department', 'name', 'date_start', 'date_end'])"
        :config="{ dense: true }"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { autoHeightBlock, getAccess } from "../../components/mixings";
export default {
  mixins: [autoHeightBlock, getAccess],
  components: {},
  props: {
    id: Number,
  },
  data() {
    return {
      showEditDialog: false,
      loading: false,
      title: "",
      data: {},
      model: this.$store.getters["config/get"].models.works.form,
      url: "/mechti/construction-schedule",
      blockHeight: 256,
    };
  },
  created() {
    this.fitchData();
  },
  mounted() {},

  computed: {
    photo: {
      get() {
        let res = this.data.data?.photo || [];
        return res;
      },
    },
    link: {
      get() {
        let res = this.data.data?.link || "";
        return res;
      },
    },
    description: {
      get() {
        let res = this.data.data?.description || "";
        return res;
      },
    },
  },
  watch: {},
  methods: {
    async fitchData() {
      this.loading = true;

      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
        this.data.description = this.description;
        this.data.link = this.link;
        this.data.photo = this.photo;
      }
      this.loading = !true;
    },
    getFormModel(arr) {
      /* let res = this.model.filter((el) => {
        return arr.includes(el.name);
      }); */
      let res = [];
      arr.forEach((el) => {
        res = [
          ...res,
          this.model.filter((m) => {
            return m.name == el;
          })[0],
        ];
      });
      res.forEach((el) => {
        if (!el?.type) {
          el.type = el?.hiddenType || "string";
        }
      });

      return res;
    },
  },
};
</script>
